<div class="ml-5">
  <p class="titre1 m-4">
    {{ 'PROFIL_UTILISATEUR.TITLE' | translate }}
    <mat-icon
      class="material-symbols-outlined text-[38px] w-[45px] h-[45px] mt-[5px] mr-[30px] float-right">person</mat-icon>
  </p>
  <div class="container mx-auto">
    <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
      <app-profil-utilisateur-card [textColor]="'text-white'" [bgColor]="'bg-orangeNovo'"
        [title]="'PROFIL_UTILISATEUR.PAGE_CONTENUS_SESSION' | translate" [icon]="'monitoring'"
        [routerLink]="'/contenus-managment/profil-utilisateur/complete/0'">
      </app-profil-utilisateur-card>
      <app-profil-utilisateur-card [textColor]="'text-white'" [bgColor]="'bg-jauneNovo'"
        [title]="'PROFIL_UTILISATEUR.PAGE_GESTION_DOCUMENT' | translate" [icon]="'folder'"
        [routerLink]="'/document-utlisateur'">
      </app-profil-utilisateur-card>
      <app-profil-utilisateur-card [textColor]="'text-white'" [bgColor]="'bg-vertFonceNovo'"
        [title]="'PROFIL_UTILISATEUR.PAGE_PARAMETRE' | translate" [icon]="'manage_accounts'"
        [routerLink]="'/parametre-utlisateur'">
      </app-profil-utilisateur-card>
      <app-profil-utilisateur-card [textColor]="'text-white'" [bgColor]="'bg-blueCielNovo'"
        [title]="'PROFIL_UTILISATEUR.PAGE_INFORMATION_PERSONNEL' | translate" [icon]="'contact_page'"
        (cardClick)="goToSSO()">
      </app-profil-utilisateur-card>
    </div>
  </div>
</div>